import Alpine from "alpinejs";

const LS_KEY_GUEST_TOKEN = "kht-guest-token";

Alpine.store("auth", {
    isLoggedIn: false,
    user: null,

    isGuest: false,
    guestToken: null,

    async init() {
        this.initGuest();
        await this.initUser();
    },

    async initUser() {
        try {
            // route.api.user
            const response = await fetch(`/api/kht/${document.documentElement.lang}/user`);
            if(!response.ok){
                throw new Error("Unable to fetch user.");
            }

            const json = await response.json();
            if(!json.success){
                throw new Error("Unable to fetch user.");
            }

            this.isLoggedIn = true;
            this.user = json.data;
            this.isGuest = false;
            this.guestToken = null;
            localStorage.removeItem(LS_KEY_GUEST_TOKEN);
        } catch (e) {
            this.isLoggedIn = false;
            this.user = null;
        }
    },

    initGuest() {
        if (!localStorage.getItem(LS_KEY_GUEST_TOKEN)) {
            return;
        }

        if (this.isLoggedIn) {
            localStorage.removeItem(LS_KEY_GUEST_TOKEN);
            return;
        }

        this.isGuest = true;
        this.guestToken = localStorage.getItem(LS_KEY_GUEST_TOKEN);
    },

    async loginAsGuest() {
        try {
            // route.api.shop.cart.create-guest
            const response = await fetch(`/api/kht/webshop/${document.documentElement.lang}/cart/create-guest`);
            const json = await response.json();

            if (json.success) {
                this.isGuest = true;
                this.guestToken = json.data.token;
                localStorage.setItem(LS_KEY_GUEST_TOKEN, this.guestToken);
            }
        } catch (e) {
            this.isGuest = false;
            this.guestToken = null;
            localStorage.removeItem(LS_KEY_GUEST_TOKEN);
        }
    },
});
